import { readStorageJson } from '../../../../utils/safeJson'
import { getOrganizationSnapshot } from '../../../../state/organizationContext'
import { EXTERNAL_ALL_HISTORY_HOURS } from '../../../../constants/durationFilters'
import {
  alarmStorageKey,
  hasAlarmStorage,
  readAlarmStorage,
  saveAlarmStorageValues,
} from '../../../../storage/alarmFilterStorage'
import { BRAND_FEATURES, isBrandFeatureEnabled } from '../../../../config/brand'

export { alarmStorageKey, readAlarmStorage }

export const ALARM_REFRESH_INTERVAL = 5000
export const DEFAULT_HISTORY_DURATION_HOURS = 10000
export const EXTERNAL_HISTORY_DURATION_FILTER = { hours: EXTERNAL_ALL_HISTORY_HOURS, option: 'HOURS_DURATION' }

const PAGE_SIZE_OPTIONS = [5, 10, 20, 50]
const INSEL_PAGE_SIZE_OPTIONS = [...PAGE_SIZE_OPTIONS, 200]

const ALARM_JOB_STATUSES = [
  'NEW',
  'CONFIG_PROBLEM',
  'INACTIVE',
  'FAILURE',
  'FINISHED',
  'INTERRUPTED',
  'CANCELED',
  'NOT_ACCEPTED',
  'NOT_ACKNOWLEDGED',
  'PARTIAL_ACCEPTED',
  'ACCEPTED',
  'PROCESSING',
  'PARTIAL_ACKNOWLEDGED',
  'ACKNOWLEDGED',
  'SCHEDULED',
]

const ALARM_TABLE_FILTER_KEYS = [
  { label: 'Name', value: 'alarmPointName' },
  { label: 'Alarm Point Id', value: 'alarmPointId' },
  { label: 'System ID', value: 'alarmPointSysId' },
  { label: 'Triggered By', value: 'triggeredBy' },
  { label: 'Alarm Job Status', value: 'alarmJobStatus' },
]

export function createDefaultAlarmRow() {
  return {
    alarmPointName: '',
    jobStatusColor: '',
  }
}

export function createDefaultAlarmFilters() {
  return {
    alarmName: null,
    alarmPointId: '',
    statuses: [],
    systemId: null,
    triggeredBy: null,
  }
}

export function createDefaultDurationFilters() {
  return {
    start: null,
    end: null,
    hours: 23,
    option: 'HOURS_DURATION',
  }
}

export function createPageSizeOptions(context) {
  return isBrandFeatureEnabled(BRAND_FEATURES.INSEL_ALARM_TABLE, context)
    ? [...INSEL_PAGE_SIZE_OPTIONS]
    : [...PAGE_SIZE_OPTIONS]
}

export function createAlarmJobStatuses() {
  return [...ALARM_JOB_STATUSES]
}

export function createAlarmTableFilterKeys() {
  return ALARM_TABLE_FILTER_KEYS.map((item) => ({ ...item }))
}

export function readAlarmTableRows(context) {
  const storedRows = readStorageJson('alarmTableRows', 10)
  return createPageSizeOptions(context).includes(storedRows) ? storedRows : 10
}

export function readStoredHoursDuration(filtersPrefix) {
  return readAlarmStorage(filtersPrefix, 'durationFilters')?.hours ?? 23
}

export function createInitialDurationFilters(filtersPrefix) {
  return readAlarmStorage(filtersPrefix, 'durationFilters') ?? createDefaultDurationFilters()
}

export function buildTableFiltersPayload({
  durationFilters,
  sortKey,
  alarmFilterValue,
  alarmTableRows,
  orgFilter,
  currentPage,
  alarmFilters,
  participantsFilter = undefined,
}) {
  const payload = {
    durationFilters,
    sortKey,
    alarmFilterValue,
    alarmTableRows,
    orgFilter,
    currentPage,
    alarmFilters,
    multiOrgData: getOrganizationSnapshot().multiOrgData,
  }

  if (typeof participantsFilter !== 'undefined') {
    payload.participantsFilter = participantsFilter
  }

  return payload
}

export function loadLocalAlarmFilters(filtersPrefix) {
  const fields = [
    'currentPage',
    'sortKey',
    'alarmFilterKey',
    'alarmFilterValue',
    'alarmTableRows',
    'alarmFilters',
    'durationFilters',
    'orderByPriority',
    'participantsFilter',
  ]

  return fields.reduce((values, field) => {
    if (hasAlarmStorage(filtersPrefix, field)) {
      values[field] = readAlarmStorage(filtersPrefix, field)
    }

    return values
  }, {})
}

export function saveLocalAlarmFilters(filtersPrefix, values) {
  saveAlarmStorageValues(filtersPrefix, values)
}
